export default function stickyRevealHeader(selector = '[data-header]') {
  const headers = Array.from(document.querySelectorAll(selector));
  if (!headers.length) return;

  const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const split = (s) => (s ? s.split(/\s+/).filter(Boolean) : []);

  const stateByEl = new Map(
    headers.map((el) => [
      el,
      {
        lastY: window.scrollY || 0,
        ticking: false,
        bg: el.dataset.headerBg || '',
        noBg: el.dataset.headerNoBg || '',
        bgImage: el.dataset.headerBgImage || '', // ✅ NEW
        hidden: el.dataset.headerHidden || '-translate-y-full',
        visible: el.dataset.headerVisible || 'translate-y-0',
        threshold: Number(el.dataset.headerThreshold || 8),
        isHidden: false,
      },
    ])
  );

  headers.forEach((el) => {
    // el.classList.add('fixed', 'top-0', 'left-0', 'w-full');

    if (!prefersReduced) {
      el.classList.add(
        'transform-gpu',
        'transition-[transform,background-color,background-image,backdrop-filter]',
        'duration-300',
        'ease-out'
      );
    }
  });

  function setBg(el, mode /* 'top' | 'scrolled' */) {
    const s = stateByEl.get(el);
    const bg = split(s.bg);
    const noBg = split(s.noBg);
    const bgImage = split(s.bgImage);
    const url = el.dataset.headerBgImageUrl;

    if (mode === 'top') {
      if (bg.length) el.classList.remove(...bg);
      if (bgImage.length) el.classList.remove(...bgImage); // remove image at top/hidden
      if (noBg.length) el.classList.add(...noBg);
      el.style.backgroundImage = '';
      return;
    }

    if (url) el.style.backgroundImage = `url("${url}")`;
    if (noBg.length) el.classList.remove(...noBg);
    if (bg.length) el.classList.add(...bg);
    if (bgImage.length) el.classList.add(...bgImage); // add image when scrolled + visible
  }

  function show(el) {
    const s = stateByEl.get(el);
    el.classList.remove(...split(s.hidden));
    el.classList.add(...split(s.visible));
    s.isHidden = false;
  }

  function hide(el) {
    const s = stateByEl.get(el);
    el.classList.remove(...split(s.visible));
    el.classList.add(...split(s.hidden));
    s.isHidden = true;
  }

  function apply(el) {
    const s = stateByEl.get(el);
    const y = window.scrollY || 0;
    const delta = y - s.lastY;

    const atTop = y <= 0;
    const scrollingDown = delta > s.threshold;
    const scrollingUp = delta < -s.threshold;

    if (!atTop && scrollingDown) hide(el);
    else if (scrollingUp || atTop) show(el);

    // bg + image only when header is visible
    if (atTop) setBg(el, 'top');
    else setBg(el, s.isHidden ? 'top' : 'scrolled');

    s.lastY = y;
  }

  function onScroll() {
    headers.forEach((el) => {
      const s = stateByEl.get(el);
      if (s.ticking) return;
      s.ticking = true;

      requestAnimationFrame(() => {
        apply(el);
        s.ticking = false;
      });
    });
  }

  headers.forEach((el) => apply(el));
  window.addEventListener('scroll', onScroll, { passive: true });

  return () => window.removeEventListener('scroll', onScroll);
}
